module.exports = __webpack_public_path__ + "img/banner-2.2513e832.png";